module.exports = __webpack_public_path__ + "static/media/ceiling.84a35f5d.png";